import {
  Autocomplete,
  CircularProgress,
  Grid,
  IconButton,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
} from '@mui/material';
import Backdrop from '@mui/material/Backdrop';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Fade from '@mui/material/Fade';
import Modal from '@mui/material/Modal';
import Typography from '@mui/material/Typography';
import * as React from 'react';
import { Trash } from 'react-feather';
import { useParams } from 'react-router-dom';
import Iconify from 'src/components/iconify';
import { TreePostAttachment } from 'src/components/services/httpServices';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 1200,
  bgcolor: 'background.paper',
  borderRadius: '25px',
  boxShadow: 24,
  p: 4,
};

export default function AddAttachmentsModal(props) {
  const [open, setOpen] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [selectedFile, setSelectedFile] = React.useState([]);
  let { id, checkClient } = useParams();
  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setSelectedFile([]);
    setOpen(false);
  };
  const attachmentRef = React.useRef(null);
  // console.log('props', props);
  const folderNameRef = React.useRef('');
  React.useEffect(() => {}, [selectedFile]);
  const saveAttachment = async (event) => {
    event.preventDefault();

    setLoading(true);
    props.setLoading(true);
    var payload = {
      attachments: selectedFile,
      path: props?.rightClickedNode?.path,
    };
    //  console.log(payload);

    let response = await TreePostAttachment(id, payload, checkClient);

    console.log('PostResponse:', response);
    if (response.status == 200) {
      setSelectedFile([]);
      props.setMessage(response.data);
      props.setSaved(true);
      props.setOpen(true);
      props.setLoading(false);
      setLoading(false);
    } else {
      props.setMessage(response.data);
      props.setSaved(false);
      props.setOpen(true);
      setLoading(false);
      props.setLoading(false);
      // setPosting(false);
    }
    handleClose();
  };
  const ChangeDateHandle = (event, index) => {
    selectedFile[index].scannedDate = event.target.value;
    setScannedDate(event.target.value);
    //  console.log(index);
    console.log(event.target.value);
    //  console.log(selectedFile);
  };
  const ChangeDocTypeHandle = (event, index, type) => {
    //  console.log(index);
    //  console.log(type);
    selectedFile[index].docType = type?.value;
  };
  const ChangeExpiryDateHandle = (event, index) => {
    selectedFile[index].docExpiryDate = event.target.value;
    // console.log(selectedFile);
  };
  const docTypes = [
    { value: 'Permit' },
    { value: 'Communication' },
    { value: 'Submission' },
    { value: 'Questionnaire' },
    { value: 'Fee Receipt' },
    { value: 'Invoice' },
    { value: 'Passport' },
    { value: 'Work permit' },
    { value: 'LMIA' },
    { value: 'Education' },
    { value: 'Employment reference' },
    { value: 'Alberta job offer' },
    { value: 'Pay stubs' },
    { value: 'Proof of funds' },
    { value: 'Dependent form' },
    { value: 'Use of rep' },
    { value: 'Questionnaire' },
    { value: 'T4 summary' },
    { value: 'Attestation letter' },
    { value: 'Additional Documents' },
  ];
  const deleteAttachmentRow = (fileName) => {
    // console.log(selectedFile);
    const newList = selectedFile.filter((item) => item.fileName !== fileName);
    //  console.log('new List', newList);

    // setGrandTotal(parseInt(grandTotal) - price * quantity);
    setSelectedFile(newList);
  };
  const currentDate = new Date();
  const currentHour = currentDate.getHours().toString().padStart(2, '0');
  const currentMinute = currentDate.getMinutes().toString().padStart(2, '0');
  const currentTime = `${currentHour}:${currentMinute}:00`;

  const currentYear = currentDate.getFullYear().toString();
  const currentMonth = (currentDate.getMonth() + 1).toString().padStart(2, '0'); // add 1 to get the correct month
  const currentDay = currentDate.getDate().toString().padStart(2, '0');
  const currentDateStr = `${currentYear}-${currentMonth}-${currentDay}`;
  const uploadFile = (event) => {
    event.preventDefault();
    const uploaded = [...selectedFile];
    for (let i = 0; i < event.target.files.length; i++) {
      let reader = new FileReader();
      let file = event.target.files[i];
      // console.log('FileName', file); //I can see the file's info

      reader.onload = (event) => {
        //  console.log('event', event.target.result[i]);
        // console.log("asas", reader.result);
        const row = {
          attachment: reader.result,
          fileName: file.name,
          docType: '',
          scannedDate: currentDateStr,
          docExpiryDate: '',
        };
        uploaded.push(row);
        setSelectedFile(uploaded);
        // console.log('row', row);
        // console.log("State", selectedFile);
      };
      reader.readAsDataURL(file);

      // console.log('asas', reader.result);
      reader.onerror = function (error) {
        //     console.log('Error: ', error);
      };
    }
    //setSelectedFile(uploaded);
  };

  return (
    <div>
      <Stack direction="row" onClick={handleOpen}>
        <Iconify icon={props.icon} sx={{ mr: 2 }} />
        <Typography variant="subtitle2">{props.title}</Typography>
      </Stack>

      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
        onClose={handleClose}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500,
          },
        }}
      >
        <Fade in={open}>
          <Box sx={style}>
            <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
              <Typography variant="h4" gutterBottom>
                Add Documents
              </Typography>
              <TextField
                type="file"
                label=""
                inputProps={{ multiple: true }}
                inputRef={attachmentRef}
                onChange={uploadFile}
              />
            </Stack>
            {loading ? (
              <Grid display="flex" alignItems="center" justifyContent="center" height="40vh" container>
                <CircularProgress size={60} thickness={3} value={100} />
              </Grid>
            ) : (
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <br></br>
                  <br></br>
                  <TableContainer component={Paper}>
                    <Table size="small">
                      <TableHead>
                        <TableRow>
                          <TableCell>Sr#</TableCell>

                          <TableCell>Attachment Name</TableCell>
                          <TableCell>Scanned Date</TableCell>
                          <TableCell>Document Type</TableCell>
                          <TableCell>Document Expiry Date</TableCell>
                          <TableCell>Actions</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {selectedFile?.map((row, index) => (
                          <TableRow key={index + 1}>
                            <TableCell>{index + 1}</TableCell>

                            <TableCell>{row.fileName}</TableCell>

                            <TableCell>
                              <TextField
                                label="Scaned Date"
                                variant="outlined"
                                fullWidth
                                defaultValue={currentDateStr}
                                size="small"
                                type="date"
                                onChange={(event) => ChangeDateHandle(event, index)}
                                InputLabelProps={{ shrink: true }}
                              />{' '}
                            </TableCell>

                            <TableCell>
                              <Autocomplete
                                id="docType"
                                size="small"
                                options={docTypes}
                                // defaultValue={userList.find((e) => e.key == user.deptId)}
                                getOptionLabel={(source) => source.value}
                                renderInput={(params) => <TextField {...params} label="Doc Type" variant="outlined" />}
                                onChange={(event, type) => ChangeDocTypeHandle(event, index, type)}
                              />
                            </TableCell>
                            <TableCell>
                              <TextField
                                label="Doc Expiry Date"
                                variant="outlined"
                                fullWidth
                                size="small"
                                type="date"
                                onChange={(event) => ChangeExpiryDateHandle(event, index)}
                                InputLabelProps={{ shrink: true }}
                              />{' '}
                            </TableCell>
                            <TableCell>
                              <IconButton
                                onClick={() => deleteAttachmentRow(row.fileName)}
                                aria-label="delete"
                                size="small"
                              >
                                <Trash />
                              </IconButton>
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Grid>
              </Grid>
            )}
            <Stack direction="row" justifyContent="end" alignItems="flex-end" spacing={2} marginTop={8}>
              <Button onClick={saveAttachment} variant="contained">
                Save
              </Button>
              <Button onClick={handleClose} variant="contained">
                Close
              </Button>
            </Stack>
          </Box>
        </Fade>
      </Modal>
    </div>
  );
}
